__turbopack_context__.v({
  "root": "DesktopRecoveryComponent-module__EonB-a__root",
});
